// ============================================================
// useTeacherDashboard Hook
// ============================================================

import { useEffect, useMemo } from 'react';
import useTeacherStore from '@/store/teacherStore';
import { useAuth } from './useAuth';

export function useTeacherDashboard() {
  const { user } = useAuth();
  
  const dashboard = useTeacherStore((s) => s.dashboard);
  const loading = useTeacherStore((s) => s.dashboardLoading);
  const error = useTeacherStore((s) => s.error);
  const fetchTeacherDashboard = useTeacherStore((s) => s.fetchTeacherDashboard);

  // Extract the ID dynamically based on various backend JWT payload formats
  const teacherId = useMemo(() => {
    return user?.staff_id || user?.teacher_id || user?.teacherId || user?.id;
  }, [user]);

  useEffect(() => {
    if (teacherId) {
      fetchTeacherDashboard(teacherId);
    }
  }, [teacherId, fetchTeacherDashboard]);

  return { 
    dashboard, 
    loading, 
    error, 
    refetch: () => {
      if (teacherId) fetchTeacherDashboard(teacherId);
    } 
  };
}

